export function Api(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.29717 14.475C4.29717 14.765 4.06212 15 3.7722 15C3.50643 15 3.28679 14.8025 3.25202 14.5462L3.24723 14.475L3.24663 11.5008L2.72516 11.5013C1.89161 11.5013 1.2093 10.8537 1.15389 10.0342L1.15026 9.92636V6.07658C1.15026 5.38748 1.59284 4.80175 2.20925 4.58813L2.20883 1.52497C2.20883 1.25919 2.40632 1.03955 2.66256 1.00479L2.73379 1H7.2841C7.5498 1 7.76945 1.19749 7.80423 1.45373L7.80906 1.52497L7.80927 4.59467C8.38037 4.80064 8.79817 5.32731 8.84535 5.9573L8.84976 6.07658V9.92636C8.84976 10.7599 8.20223 11.4422 7.38272 11.4976L7.27486 11.5013L6.74639 11.5008L6.74709 14.4729C6.74709 14.7629 6.51204 14.9979 6.22212 14.9979C5.95635 14.9979 5.7367 14.8004 5.70191 14.5441L5.69715 14.4729L5.69645 11.5008H4.29654L4.29717 14.475ZM7.27486 5.55162H2.72516C2.45939 5.55162 2.23974 5.74912 2.20498 6.00535L2.2002 6.07658V9.92636C2.2002 10.1921 2.39769 10.4118 2.65392 10.4465L2.72516 10.4513L6.22212 10.4492L6.25222 10.4508L7.27486 10.4513C7.54063 10.4513 7.76028 10.2538 7.79506 9.99762L7.79982 9.92636V6.07658C7.79982 5.81082 7.60237 5.59117 7.34611 5.55641L7.27486 5.55162ZM6.75892 2.04973H3.25843V4.50098H6.75892V2.04973Z"
          fill="currentColor"
          stroke="#DA2E9A"
          strokeWidth="0.5"
        />
      </svg>
    </div>
  );
}
